import AppBar from '@material-ui/core/AppBar'
import Box from '@material-ui/core/Box'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Typography from '@material-ui/core/Typography'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'
import SwipeableViews from 'react-swipeable-views'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={6}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
}))

const AnalyticsView = () => {
  const classes = useStyles()
  const theme = useTheme()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleChangeIndex = (index) => {
    setValue(index)
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Eficiéncia" {...a11yProps(0)} />
          <Tab label="Reserva" {...a11yProps(1)} />
          <Tab label="Motos" {...a11yProps(2)} />
          <Tab label="Mapa Calor" {...a11yProps(3)} />
          <Tab label="Usuarios App" {...a11yProps(4)} />
          <Tab label="SLA" {...a11yProps(5)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          Indicador de eficiencia de flota
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          Duración media de las reservas
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          Ocupación media de las motos
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          Mapa de calor para representar los usos por zonas
        </TabPanel>
        <TabPanel value={value} index={4} dir={theme.direction}>
          Usuarios de la APP (Altas/Bajas)
        </TabPanel>
        <TabPanel value={value} index={5} dir={theme.direction}>
          SLA con los indicadores de calidad de servicio acordados con los
          operadores externos
        </TabPanel>
      </SwipeableViews>
    </div>
  )
}

export default AnalyticsView
